import { useMutation } from "react-query";
import { updateSocialHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpdateSocialHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ id, payload }: { id: number; payload: Record<string, any> }) =>
      updateSocialHistory(id, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while updating the social history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    updateSocialHistoryMutation: mutate,
    isUpdateSocialHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpdateSocialHistory;
